<template>
  <div class="d-flex">
    <v-card class="w-full" style="position: relative" rounded="xl">
      <div id="mapContainer" class="w-full h-full" />

      <div
        style="
          position: absolute;
          bottom: 15px;
          left: 15px;
          z-index: 1000;
          max-width: min(500px, 83%);
        "
      >
        <div class="d-flex align-center rounded-lg overflow-hidden mb-2">
          <v-chip
            v-for="(status, i) in iconStatus"
            :color="status.colorHex || status.color"
            :key="status.label"
            small
            label
            class="flex-grow-1 rounded-0 text-center px-0 flex-1 justify-center"
            :class="{ 'rounded-l-none': i !== 0 }"
          >
            {{ status.label }}
          </v-chip>
        </div>
        <v-card rounded="lg" class="pa-3">
          <p v-if="!selectedParty" class="text-body-1 font-weight-bold mb-0">
            Selecione um evento para visualizar
          </p>
          <template v-else>
            <p class="text-overline mb-1 lh-1">
              {{ selectedParty.date | date("DD/MM/YYYY HH:mm") }}
            </p>
            <h6 class="mb-0">
              {{ selectedParty.name }}
            </h6>
            <p class="text-body-2 font-weight-medium mb-2">
              {{ selectedParty.Address.city }}/{{ selectedParty.Address.state }}
            </p>
            <PartyOnboarding :item="selectedParty" />
          </template>
        </v-card>
      </div>
    </v-card>
  </div>
</template>

<script>
import moment from "moment";
import PartyOnboarding from "./modules/PartyOnboarding.vue";

const baseMarkerFolder = `${window.location.origin}/img/markers/`;

export default {
  components: { PartyOnboarding },
  data: () => ({
    map: null,
    markers: new Map(),
    selectedParty: null,
    iconStatus: [
      {
        color: "error",
        timeDifference: 2,
        label: "< 2 dias",
      },
      {
        color: "warning",
        timeDifference: 3,
        label: "3 dias",
      },
      {
        color: "yellow",
        timeDifference: 7,
        label: "7 dias",
      },
      {
        color: "lime",
        timeDifference: 14,
        label: "14 dias",
      },
      {
        color: "success",
        timeDifference: 30,
        label: "30 dias",
      },
      {
        color: "info",
        colorHex: "#24bef6",
        timeDifference: 1000,
        label: "> 30 dias",
      },
    ],
  }),
  methods: {
    initMap() {
      // Centro do mapa no Brasil
      const center = { lat: -16.235, lng: -51.9253 };

      // Inicializa o mapa no modo satélite
      this.map = new google.maps.Map(document.getElementById("mapContainer"), {
        center: center,
        zoom: 4.5,
        // mapTypeId: google.maps.MapTypeId.SATELLITE,
      });

      this.addMarkers();
    },
    filterMarkers() {
      // remove markers that are not in the parties.active array
      this.markers.forEach((marker, partyId) => {
        const isActive = this.parties.active.some(
          (party) => party.id === partyId
        );

        if (!isActive) {
          marker.setMap(null);
          this.markers.delete(partyId);
        }
      });
    },
    addMarkers() {
      this.parties.active.forEach((party) => {
        if (this.markers.has(party.id)) return;
        if (!party.Address || !!party.ParentParty) return;
        const marker = new google.maps.Marker({
          position: {
            lat: party.Address.lat,
            lng: party.Address.lng,
          },
          icon: {
            url: this.getMarkerUrl(party),
            scaledSize: new google.maps.Size(28, 40),
            size: new google.maps.Size(28, 40),
            anchor: new google.maps.Point(28, 40),
          },
        });

        marker.addListener("click", () => this.selectParty(party));
        marker.setMap(this.map);
        this.markers.set(party.id, marker);
      });
    },
    getMarkerUrl(party) {
      const aDay = 1000 * 60 * 60 * 24;
      const statusList = this.iconStatus;

      const diff = moment(party.date).diff(moment());
      const status = statusList.find((s) => diff < aDay * s.timeDifference);

      return `${baseMarkerFolder}marker-${status?.color || "info"}.png`;
    },

    selectParty(party) {
      this.selectedParty = party;
      // this.map.setZoom(10);
      this.map.panTo({
        lat: party.Address.lat,
        lng: party.Address.lng,
      });
    },
  },
  watch: {
    parties: {
      handler() {
        this.filterMarkers();
        this.$nextTick(() => this.addMarkers());
      },
      deep: true,
    },
  },

  props: {
    parties: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    if (typeof google === "undefined") {
      const script = document.createElement("script");
      script.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.VUE_APP_MAPS_KEY}`;
      document.head.appendChild(script);
      script.onload = () => this.initMap();
    } else {
      this.initMap();
    }
  },
};
</script>

<style lang="scss">
#mapContainer {
  border-radius: 10px;
  overflow: hidden;
  height: calc(100vh - 240px);
}
</style>
